import { c as _c } from "react/compiler-runtime";
import { useLocation } from 'react-router-dom';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

// PostHog experiment driving the CON-8444 gallery A/B test. `test` is the
// redesigned gallery, `control` (or no value) keeps the current one.
// The server reads the same flag, so renaming it here also means renaming
// PDP_GALLERY_REVAMP_FLAG in consumer's config/postHogConstants.js.
export const PDP_GALLERY_REVAMP_FLAG = 'pdp-gallery-revamp';
export const PDP_GALLERY_REVAMP_TEST_VARIANT = 'test';

// `?galleryRevamp=1` forces the redesign on any environment so design and QA can
// review it without waiting on a bucket assignment. `?galleryRevamp=0` forces
// the control back for the same reason.
const readPreviewOverride = search => {
  const value = new URLSearchParams(search).get('galleryRevamp');
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  return null;
};
const useIsGalleryRevampVariant = () => {
  const $ = _c(2);
  const {
    search
  } = useLocation();
  const flagValue = usePostHogFeatureFlag(PDP_GALLERY_REVAMP_FLAG);
  let t0;
  if ($[0] !== search) {
    t0 = readPreviewOverride(search);
    $[0] = search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const previewOverride = t0;
  if (previewOverride !== null) {
    return previewOverride;
  }
  return flagValue === PDP_GALLERY_REVAMP_TEST_VARIANT;
};
export default useIsGalleryRevampVariant;